import FieldProject from "../../../generic/entity/project/project";
import FieldConfig from "../../../../fields3/proto/field-config";

export default class FieldProjectTemplate extends FieldProject {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Project Type";
        this.icon       = 'i5-task-types'
    }

    getViewValue(model:any) {
        // hm a pochemu v model netuy ?
        return model[this.fieldId] ? model[this.fieldId] : gd.session.projects.get(model.id)!.localTemplateId;
    }
}